import type { IFrame } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import type { SnapLineContext } from '@src/slide/application/service/snap-line-service/context';
import { IAdsorbResult } from '@src/slide/application/service/snap-line-service/interface/snap-line-service.interface';
import {
    autoFitNoChangeAspectOffsetFrame,
} from '@src/slide/application/service/snap-line-service/util/frame';

/**
 * 在操作结束后，patch提交者
 * 注意：此 committer不提交 cs，只提交 offsetFrame 的更新。落盘由上层负责
 */
export class SnapLineCommitter {
    public constructor(protected context: SnapLineContext) {}

    public commit(adsorbResult?: IAdsorbResult) {
        const patch = adsorbResult?.framePatch;
        if (!patch) return;

        this.updateOperateOffsetFrame(patch);
        this.updateRelativeOffsetFrame(patch);
    }

    /* 更新当前操作元素的 offsetFrame */
    private updateOperateOffsetFrame(patch: IFrame) {
        this.updateOffsetFrameWithPatch(this.context.offsetFrame, patch);
        // this.handleNoChangeAspectOffsetFrame(this.context.offsetFrame);
    }

    /* 更新sizeMap 中所有关联元素的 offsetFrame，”多选“需要更新所有选中的 offsetFrame */
    private updateRelativeOffsetFrame(patch: IFrame) {
        const { sizeMap } = this.context;

        if (sizeMap?.size && sizeMap.size > 1) {
            sizeMap.forEach((sizeInfo) => {
                this.updateOffsetFrameWithPatch(sizeInfo.offsetFrame, patch);
            });
        }
    }

    private updateOffsetFrameWithPatch(offsetFrame: any, patch: IFrame) {
        const patchResult = this.getOffsetFrameResult(offsetFrame, patch);

        offsetFrame.top = patchResult.top;
        offsetFrame.left = patchResult.left;
        offsetFrame.width = patchResult.width;
        offsetFrame.height = patchResult.height;
    }

    private getOffsetFrameResult(offsetFrame: any, patch: IFrame) {
        const { nextSize, originalSize } = this.context;
        const targetTop = nextSize.top + patch.top;
        const targetLeft = nextSize.left + patch.left;
        const targetHeight = nextSize.height + patch.height;
        const targetWidth = nextSize.width + patch.width;

        return {
            top: patch.top ? targetTop - originalSize.top : offsetFrame.top,
            left: patch.left ? targetLeft - originalSize.left : offsetFrame.left,
            height: patch.height ? targetHeight - originalSize.height : offsetFrame.height,
            width: patch.width ? targetWidth - originalSize.width : offsetFrame.width,
        };
    }

    private handleNoChangeAspectOffsetFrame = (offsetFrame: any) => {
        const { noChangeAspect, originOperationAnchor, activeSnapLines, elementScale } = this.context;
        if (!noChangeAspect) {
            return;
        }

        autoFitNoChangeAspectOffsetFrame(activeSnapLines, offsetFrame, originOperationAnchor, elementScale);
    };
}
